import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { BRANDED_COLOURS } from '@constants';

export const PROFILE_FIELDS = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title',
    rules: [{ required: true, message: 'Title is required' }],
  },
  NAME: {
    name: 'name',
    label: 'Name:',
    placeholder: 'Enter a name',
    rules: [{ required: true, message: 'Name is required' }],
  },
  ORGANISATION: {
    name: 'organisation',
    label: 'Organisation:',
    placeholder: 'Enter a organisation',
  },
  DESCRIPTION: {
    name: 'biography',
    label: 'Biography:',
    placeholder: 'Enter a biography',
    rules: [{ required: true, message: 'Biography is required' }],
  },
  IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['600x850'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  COLOR: {
    name: 'color',
    label: 'Color:',
    colors: [...BRANDED_COLOURS],
  },
};

export const PROFILES = {
  name: 'profiles',
  rules: [{ min: 1 }],
  serialize: (field, values) => {
    const value = values[field.name];
    return {
      profiles: value,
    };
  },
};

export const FORM_PANEL = { PROFILES };

export const PROFILE_INITS = {
  section: [],
};
